import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import { GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_BOLD } from '../../styles/variables';

export const AddToProduct = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  margin: 50px 0px 120px;
  padding-left: 30px;
`;

export const Info = styled.div`
  max-width: 400px;
  p:first-of-type {
    margin-top: 10px;
  }
`;

export const BoxContent = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const ProductOptions = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const CustomIcon = styled.div`
  margin: 0;
  margin-right: 10px;
  height: 30px;
`;

export const ButtonSeparator = styled.p`
  margin: 0px 15px;
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
`;



// WEBPACK FOOTER //
// ./src/components/SelectProductAddons/style.js